import { render } from "./TextMarquee.vue?vue&type=template&id=5d95659f&scoped=true"
import script from "./TextMarquee.vue?vue&type=script&lang=js"
export * from "./TextMarquee.vue?vue&type=script&lang=js"

import "./TextMarquee.vue?vue&type=style&index=0&id=5d95659f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d95659f"]])

export default __exports__